import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import styled from '@emotion/styled';
import { breakpoint } from 'styles/breakpoints';

const Wrapper = styled.main`
  padding: ${({ isAuthPage, isHomepage }) =>
    // eslint-disable-next-line no-nested-ternary
    isAuthPage ? 0 : isHomepage ? '210px 0 45px' : '30px 0'};
  margin: auto 0;

  @media screen and ${breakpoint.md} {
    margin: 0;
    flex: 1;
    display: flex;
    min-height: ${({ isHomepage }) => (isHomepage ? '900px' : 'unset')};
    padding: ${({ isAuthPage }) =>
      // eslint-disable-next-line no-nested-ternary
      isAuthPage ? 0 : '30px 0'};
  }
`;

const MainContent = ({ children }) => {
  const { pathname } = useLocation();
  const isAuthPage = useMemo(() => pathname.indexOf('auth') !== -1, [pathname]);
  const isHomepage = useMemo(() => pathname === '/', [pathname]);

  return (
    <Wrapper isAuthPage={isAuthPage} isHomepage={isHomepage}>
      {children}
    </Wrapper>
  );
};

export default MainContent;
